import { render, staticRenderFns } from "./FeedbackForm.vue?vue&type=template&id=3b7b479e&scoped=true"
import script from "./FeedbackForm.vue?vue&type=script&lang=js"
export * from "./FeedbackForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7b479e",
  null
  
)

export default component.exports